<template>
  <Modal title="Colors/Icon Key" no-footer @hide-modal="emit('hide-modal')">
    <div class="flex flex-col md:max-h-70dvh md:overflow-auto">
      <div>Status Colors</div>
      <div class="divide-y px-3">
        <div v-for="status in statusOrder" :key="status" class="py-4">
          <div
            class="grid grid-rows-2 grid-cols-1 flex-wrap md:grid-cols-3 md:grid-rows-1"
          >
            <div>
              <TagItem
                :label="APPOINTMENT_SCHEDULE_LEGEND[status]?.label"
                no-icon
                :text-color="getTextColor(status)"
                :background-color="getBGColor(status)"
                :class="`rounded-lg ${getTagClass(status)} max-w-full`"
              >
                <div class="flex items-center text-xs gap-1">
                  <div
                    class="w-3 h-3 rounded-full shrink-0"
                    :style="{
                      background: getStatusColor(status)
                    }"
                  ></div>
                  <div class="font-bold">
                    {{ APPOINTMENT_SCHEDULE_LEGEND[status]?.label }}
                  </div>
                  <div>
                    {{ APPOINTMENT_SCHEDULE_LEGEND[status]?.subLabel }}
                  </div>
                </div>
              </TagItem>
            </div>
            <div class="text-body col-span-2">
              {{ APPOINTMENT_SCHEDULE_LEGEND[status]?.description }}
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4">Icons</div>
      <div class="divide-y px-3">
        <div v-for="icon in icons" :key="icon.label" class="py-4">
          <div
            class="grid grid-rows-2 grid-cols-1 gap-2 md:grid-cols-3 md:grid-rows-1"
          >
            <div class="flex items-center gap-1 text-xs">
              <component :is="icon.icon" class="w-3 h-3" />
              <div class="font-bold">{{ icon.label }}</div>
              <div>{{ icon.subLabel }}</div>
            </div>
            <div class="text-body col-span-2">
              {{ icon.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from "vue";

import Modal from "@/components/Modal.vue";
import TagItem from "@/components/Seranova/Tags/TagItem.vue";
import CONSTANTS from "@/Constants";
import CrownSimple from "@/images/CrownSimple.svg?component";
import EmptyIcon from "@/images/Empty.svg?component";
import Lock from "@/images/lock.svg?component";
import UserCheck from "@/images/UserCheck.svg?component";
import WarningIcon from "@/images/Warning.svg?component";
import { useScheduleColors } from "@/SchedulerV2/useScheduleColors";
const { APPOINTMENT_SCHEDULE_LEGEND } = CONSTANTS;

const emit = defineEmits(["hide-modal"]);

const { getBGColor, getStatusColor, getTextColor } = useScheduleColors();

const icons = ref([
  {
    icon: Lock,
    label: "Locked",
    subLabel: "(pinned)",
    description:
      "Manually assigned to a specific Technician to be worked and will not be replanned by the scheduler."
  },
  {
    icon: UserCheck,
    label: "Customer Scheduled",
    description:
      "Scheduled by the Customer (through the widget or customer portal)."
  },
  {
    icon: CrownSimple,
    label: "Membership",
    description: "Customer has an active membership."
  },
  {
    icon: WarningIcon,
    label: "Late/Attention",
    description: "Technician finished their trip after the arrival window."
  },
  {
    icon: EmptyIcon,
    label: "Not Available",
    description: "Technician is not available to be assigned appointments."
  }
]);

const statusOrder = ref([
  "pending_unassigned",
  "pending_assigned",
  "accepted_pre_work",
  "accepted",
  "traveling",
  "late",
  "running",
  "compeleted_won_opportunity",
  "compeleted_lost_opportunity",
  "hold",
  "available_event",
  "unavailable_event"
]);

const getTagClass = (status: string) => {
  switch (status) {
    case "traveling":
    case "late":
      return "md:ml-4";
    case "hold":
      return `border border-dashed border-gray-400`;
    case "available_event":
      return `border border-dashed border-gray-400`;
  }
};

defineExpose({ APPOINTMENT_SCHEDULE_LEGEND });
</script>
